import React from "react";
import { CompanyFormsStatsSkeleton } from "./CompanyFormsSkeletons";

export default function CompanyFormsStatsRow({ cards, stats, loading }) {
  if (loading) {
    return <CompanyFormsStatsSkeleton cards={cards?.length || 2} />;
  }

  return (
    <div className="company-forms-stats-grid">
      {cards.map((card) => {
        const Icon = card.Icon;
        return (
          <div
            key={card.key}
            className="flex items-center gap-3 rounded-xl border border-[#E5ECF5] bg-white px-3.5 py-3 shadow-[0_1px_2px_rgba(20,33,61,0.05)]"
          >
            <span
              className="company-forms-stat-icon flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border"
              style={{
                backgroundColor: card.iconBg || "#EFF6FF",
                borderColor: card.iconBorder || "#BFDBFE",
                color: card.color,
              }}
            >
              <Icon size={18} strokeWidth={1.75} aria-hidden />
            </span>
            <div className="min-w-0">
              <p className="text-xl font-bold tabular-nums leading-none text-[#14213D]">
                {stats[card.key] ?? 0}
              </p>
              <p className="mt-1 text-[11px] font-semibold text-[#64748B]">{card.label}</p>
              {card.sub ? (
                <p className="mt-0.5 text-[10px] text-[#94A3B8]">{card.sub}</p>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}
